/* eslint-disable max-len */
import 'react';

const HelperBtnCloseSvg = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5012_10406)">
                <path d="M0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18Z" fill="white" />
                <path d="M13.0502 13.0503L22.9497 22.9498" stroke="#3377FF" strokeWidth="1.7" strokeLinecap="round" />
                <path d="M22.9497 13.0503L13.0502 22.9498" stroke="#3377FF" strokeWidth="1.7" strokeLinecap="round" />
            </g>
            <defs>
                <clipPath id="clip0_5012_10406">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};


export default HelperBtnCloseSvg;
